import React from 'react';
import cx from 'classnames';

interface Props {
    detectionIsOn: boolean;
    width: number;
}

export const DetectionBadge = ({
    detectionIsOn,
    width,
}: Props): JSX.Element => (
    <div
        style={{ width }}
        className="flex-none h-6 px-3 rounded-full border border-tertiary-300 text-sm font-semibold text-tertiary-400"
    >
        Detection&nbsp;
        <span
            className={cx({
                'text-secondary-500': detectionIsOn,
                'text-black': !detectionIsOn,
            })}
        >
            {detectionIsOn && <>On</>}
            {!detectionIsOn && <>Off</>}
        </span>
    </div>
);
